  import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCamera,
  faCircleCheck,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FaDownload } from "react-icons/fa";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../css/userprofile.css";
import {
  addAttorneyDetails,
  changePassword,
  currentUser,
  deleteUserById,
  doLogout,
  getAttorney,
  getAttorneyDetailsByUserId,
  getBeneficiary,
  getToken,
  getTrustee,
  getUser,
  removeAttorneyFromUser,
  saveProfileImage,
  setUser,
  get2FAStatus,
  toggle2FA,
  updateAttorneyDetails,
  verifyCode,
  initiateQR,
  downloadTermsPdf,
  saveSecurityQuestions,
  toggleSecurityQuestions,
} from "../../services/user-service";
import { getTenantDetails } from "../../services/user-service";
import { Tooltip } from "@mui/material";
import { Form } from "reactstrap";
import Deletebutton from "../my-estate/Deletebutton";
import { QRCodeSVG } from "qrcode.react"; // Add this at the top


function Userprofile() {
  const navigate = useNavigate();

  const [profilePicture, setProfilePicture] = useState(null);
  const defaultProfilePicture = `${process.env.PUBLIC_URL}/img/avtar.jpg`;
  const fileInputRef = useRef(null);
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

const handleChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    setSelectedImage(file);
    setProfilePicture(file);
    setImageSrc(URL.createObjectURL(file));
    handleSave(file);
  }
};


  const [currentUserData, setCurrentUserData] = useState(getUser());
  const [tenant, setTenant] = useState(null);

 const handleSave = (file) => {
  const formData = new FormData();
  formData.append("filename", file);

  const reader = new FileReader();
  reader.onloadend = () => {
    const base64 = reader.result.split(",")[1]; // remove the "data:image/jpeg;base64,"

    saveProfileImage(formData)
      .then(() => {
        const updatedUser = {
          ...getUser(),
          image: base64, // ✅ store as base64 string
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
        setCurrentUserData(updatedUser);
        setImageSrc(`data:image/jpeg;base64,${base64}`);
        toast.success("Profile image uploaded successfully!!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      })
      .catch((error) => {
        console.error("Upload error:", error);
        toast.error("Profile upload failed. Please re-login.");
      });
  };

  reader.readAsDataURL(file);
};

  const logout = () => {
    doLogout();
    navigate("/");
  };

const storedUser = JSON.parse(localStorage.getItem("user")); // or the actual key you use
const username = storedUser?.username || null;
  // Inside Userprofile component
const [isSecurityPopupOpen, setSecurityPopupOpen] = useState(false);
const toggleSecurityPopup = () => setSecurityPopupOpen(!isSecurityPopupOpen);

const predefinedQuestions = [
  "What was your childhood nickname?",
  "What is the name of your first pet?",
  "What is your favorite teacher’s name?",
  "What is the name of the town where you were born?",
  "What is your dream job?",
  "Who was your childhood hero?",
];

const [securityData, setSecurityData] = useState({
  question1: "",
  answer1: "",
  customQuestion1: "",
  question2: "",
  answer2: "",
  customQuestion2: "",
  enabled: storedUser?.securityQuestionsEnabled || false,
});

useEffect(() => {
  if (storedUser) {
    setSecurityData((prev) => ({
      ...prev,
      enabled: storedUser.securityQuestionsEnabled || false,
    }));
  }
}, [storedUser]);
const handleSecurityChange = (e) => {
  const { name, value } = e.target;
  setSecurityData({ ...securityData, [name]: value });
};

const handleSecuritySubmit = (e) => {
  e.preventDefault();

  // Replace custom question if selected
  const q1 =
    securityData.question1 === "custom"
      ? securityData.customQuestion1
      : securityData.question1;
  const q2 =
    securityData.question2 === "custom"
      ? securityData.customQuestion2
      : securityData.question2;

  const payload = {
    username: username, // or get from context/auth
    question1: q1,
    answer1: securityData.answer1,
    question2: q2,
    answer2: securityData.answer2,
  };

  saveSecurityQuestions(payload)
    .then((res) => {
      toast.success(res, { position: toast.POSITION.BOTTOM_CENTER });
      setSecurityPopupOpen(false);
    })
    .catch((err) => {
      console.error("Error saving security questions:", err);
      toast.error("Failed to save security questions!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    });
};

let user = currentUserData;
let role = user?.role?.toLowerCase() || "";
// console.log(role);
// console.log(user.organizationName);

   // State for 2FA status
   const [twoFactorStatus, setTwoFactorStatus] = useState("LOADING...");

   useEffect(() => {
     // Fetch 2FA Status when component loads
     get2FAStatus(user.username)
    .then((status) => {
       setTwoFactorStatus(status === "ACTIVE" ? "ACTIVE" : "INACTIVE"); // Ensure correct mapping
    })
    .catch(() => {
      toast.error("Failed to load Two-Factor Authentication status.");
      setTwoFactorStatus("INACTIVE"); // Default to INACTIVE in case of error
    });
}, [user.username]);

  const handleRemove = (params) => {
    const { Id, roleText } = params;
    if (roleText === "removeUser") {
      deleteUserById(Id)
        .then(() => {
          toast.success("Account deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          logout();
        })
        .catch(() => {
          console.log("error");
        });
    } else {
      let token = "Bearer " + getToken();
      removeAttorneyFromUser(token, Id)
        .then(() => {
          toast.success("Attorney removed successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          navigate("/" + role + "/dashboard");
        })
        .catch(() => {
          console.log("hello");
        });
    }
  };
const handleDownloadTerms = () => {
  const username = getUser().username;

  downloadTermsPdf(username)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "terms_and_conditions.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((error) => {
      console.error("Failed to download PDF", error);
      toast.error("Unable to download Terms and Conditions.");
    });
};
  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  const popupRef = useRef(null);

  const [imageSrc, setImageSrc] = useState("");

const base64ToImage = () => {
  const base64String = user.image;
  if (typeof base64String === "string" && base64String.trim()) {
    setImageSrc(`data:image/jpeg;base64,${base64String.trim()}`);
  }
};
useEffect(() => {
  base64ToImage();
}, [user]);

useEffect(() => {
  if (user?.id && user?.role?.toUpperCase() === "TENANT_ADMIN") {
    getTenantDetails(user.id).then((res) => setTenant(res));
  }
}, [user]);


  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handlePassChange = (event) => {
    const { name, value } = event.target;
    setPasswordData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    const isPasswordValid =
      value.length >= 10 &&
      /[A-Z]/.test(value) &&
      /[!@#$%^&*(),.?":{}|<>0-9]/.test(value);
    setPasswordValid(isPasswordValid);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error("New password and confirm password must be the same", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    if (!isPasswordValid) {
      toast.error(
        "Password must be at least 10 characters long and include an uppercase letter, a special character, and a number.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }

    changePassword(passwordData)
      .then(() => {
        toast.success("Password changed successfully!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setPopupOpen(false);
      })
      .catch(() => {
        toast.error("Password change failed. Please check your inputs.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        toast.error("Error changing password:");
      });
  };

  const handleTogglePassword = (field) => {
    if (field === "currentPassword") {
      setShowCurrentPassword(!showCurrentPassword);
    } else if (field === "newPassword") {
      setShowNewPassword(!showNewPassword);
    } else if (field === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const [beneficiary, setBenificiary] = useState([]);
  const getBenificiarydata = () => {
    let userId = getUser().id;

    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => {});
  };

  const [trustee, setTrustee] = useState([]);
  const getTrusteedata = () => {
    let userId = getUser().id;

    let token = "Bearer " + getToken();
    getTrustee(token, userId)
      .then((res) => {
        setTrustee(res);
      })
      .catch((err) => {});
  };

  const [attorney, setAttorney] = useState(null);
  const getAttorneyData = () => {
    let userId = getUser().id;

    let token = "Bearer " + getToken();
    getAttorney(token, userId)
      .then((res) => {
        setAttorney(res);
      })
      .catch((err) => {});
  };

  let trusteeBeneficiarySection = null;
  if (role === "user") {
    trusteeBeneficiarySection = (
      <div className="userprofile_trustee_beneficiary_details">
        <div className="userprofile_trustee_beneficiary_base">

          {typeof attorney !== "string" && (
            <div className="userprofile_trustee_details">
              <h3>attorney details </h3>
              <div className="userprofile_trustee_name">
                <li style={{ listStyle: "disc", color: "black" }}>
                  {attorney?.firstName && `${attorney.firstName} `}
                  {attorney?.lastName && `${attorney.lastName}`}
                </li>
              </div>
            </div>
          )}

          <ul className="userprofile_beneficiary_details">
            <h3> Beneficiary details </h3>
            {beneficiary.map((benif) => {
              return (
                <div className="userprofile_beneficiary_name">
                  <li style={{ listStyle: "disc", color: "black" }}>
                    {benif.firstName + " "}
                    {benif.lastName}
                  </li>
                </div>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  const [data, setData] = useState({
    id: "",
    lawFirmName: "",
    barAssociationLicenseNumber: "",
    jurisdictionOfPractice: "",
    practiceArea: "",
    yearOfExp: "",
    education: "",
    professionalAffiliations: "",
    websiteUrl: "",
  });

  const handleChanges = (event, property) => {
    setData({ ...data, [property]: event.target.value });
  };

  const [hasData, setHasData] = useState(false);
  let attorneyId = 0;
  const getAttorneyDetails = () => {
    let userId = getUser().id;
    let token = "Bearer " + getToken();

    getAttorneyDetailsByUserId(token, userId)
     .then((res) => {
      if (!res || res === "" || res === null || res.success === false || res.data === null) {
        setHasData(false);
      } else {
        setData(res);
        setHasData(true);
        attorneyId = res.id;
      }
    })
      .catch((error) => {
    if (error.response && error.response.status === 404) {
      // Don't show toast, just assume no attorney data
      setHasData(false);
    } else {
      console.log(error);
    }
  });
};

  const extractSecret = (qrString) => {
    const urlParams = new URLSearchParams(qrString.split("?")[1]);
    const extractedSecret = urlParams.get("secret");

    setSecretKey(extractedSecret); // Store secret key in state

   };


  const handleVerifyOTP = () => {
    if (!otp) {
      toast.error("Please enter the OTP.");
      return;
    }

    const payload = { username: user.username, otp: otp };

    verifyCode(payload)
      .then((response) => {
        if (response) {
          toast.success("OTP verified successfully! 🎉");
          setOtpVerified(true);

          // Mark 2FA as enabled
          setTwoFactorStatus("ACTIVE");
          setShowQrPopup(false);
        } else {
          toast.error("Invalid OTP. Please try again.");
        }
      })
      .catch(() => {
        toast.error("OTP verification failed.");
        toast.error("Error:");
      });
  };

  const [showQrPopup, setShowQrPopup] = useState(false);
const [qrCode, setQrCode] = useState(null);
const [otp, setOtp] = useState("");
const [secretKey, setSecretKey] = useState(""); // Secret Key from QR
const [otpVerified, setOtpVerified] = useState(false);

const handleEnable2FA = () => {
  initiateQR({ username: user.username }) // Ensure the payload is in JSON format
    .then((qrResponse) => {
      setQrCode(qrResponse);  // Set QR Code
      extractSecret(qrResponse); // Extract Secret Key
      setShowQrPopup(true); // Show popup
    })
    .catch(() => {
      toast.error("Failed to generate QR Code.");
    });
};

  const addAttorneyDetailsForm = (event) => {
    event.preventDefault();

    let token = "Bearer " + getToken();
    const formData = new FormData();

    if (hasData === false) {
      formData.append("data", JSON.stringify(data));

      addAttorneyDetails(formData, token)
        .then((resp) => {
          toggle();
          getAttorneyDetails();
          toast.success("Other Information Saved !!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {});
    } else {
      setData({ ...data, id: attorneyId });
      formData.append("data", JSON.stringify(data));
      updateAttorneyDetails(formData, token)
        .then((resp) => {
          toggle();
          getAttorneyDetails();
          toast.success("Other Information Updated !!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {});
    }
  };

  let attorneySection = null;
  const [addAttorneyDetailButton, setAddAttorneyDetailButton] = useState(false);
  const toggle = () => {
    setAddAttorneyDetailButton(!addAttorneyDetailButton);
  };
  if (role === "attorney") {
    attorneySection = (
      <div
        className="userprofile_page_details"
        style={{ width: "100%", marginTop: "3px" }}
      >
        <div className="userprofile_container">
          <Form onSubmit={addAttorneyDetailsForm}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3>Other Information</h3>

              {hasData !== true && addAttorneyDetailButton !== true && (
                <button
                  style={{
                    height: "38px",
                    margin: "12px 20px 0 0",
                    width: "75px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="userprofile_edit_btn"
                  onClick={toggle}
                  type="button"
                >
                  Add
                </button>
              )}

              {hasData === true && addAttorneyDetailButton !== true && (
                <button
                  style={{
                    height: "38px",
                    margin: "12px 20px 0 0",
                    width: "75px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="userprofile_edit_btn"
                  onClick={toggle}
                  type="button"
                >
                  Edit
                </button>
              )}

              {addAttorneyDetailButton === true && (
                <button
                  style={{
                    height: "38px",
                    margin: "12px 20px 0 0",
                    width: "75px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="userprofile_edit_btn"
                  type="submit"
                >
                  Save
                </button>
              )}
            </div>

            <div
              style={{ width: "100%", display: "flex", flexDirection: "row" }}
            >
              <div style={{ width: "49%" }}>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list"> Law Firm Name: </li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) => handleChanges(e, "lawFirmName")}
                      value={data.lawFirmName}
                    />
                  ) : (
                    <li>{data.lawFirmName}</li>
                  )}
                </ul>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list">
                    {" "}
                    Bar Association License Number :
                  </li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) =>
                        handleChanges(e, "barAssociationLicenseNumber")
                      }
                      value={data.barAssociationLicenseNumber}
                    />
                  ) : (
                    <li>{data.barAssociationLicenseNumber}</li>
                  )}
                </ul>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list">
                    Jurisdiction of Practice:{" "}
                  </li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) =>
                        handleChanges(e, "jurisdictionOfPractice")
                      }
                      value={data.jurisdictionOfPractice}
                    />
                  ) : (
                    <li>{data.jurisdictionOfPractice}</li>
                  )}
                </ul>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list">Practice Area:</li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) => handleChanges(e, "practiceArea")}
                      value={data.practiceArea}
                    />
                  ) : (
                    <li>{data.practiceArea}</li>
                  )}
                </ul>
              </div>
              <div style={{ width: "49%" }}>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list">
                    {" "}
                    Year of Experience:{" "}
                  </li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) => handleChanges(e, "yearOfExp")}
                      value={data.yearOfExp}
                    />
                  ) : (
                    <li>{data.yearOfExp}</li>
                  )}
                </ul>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list"> Education :</li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) => handleChanges(e, "education")}
                      value={data.education}
                    />
                  ) : (
                    <li>{data.education}</li>
                  )}
                </ul>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list">
                    Professional Affiliations:{" "}
                  </li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) =>
                        handleChanges(e, "professionalAffiliations")
                      }
                      value={data.professionalAffiliations}
                    />
                  ) : (
                    <li>{data.professionalAffiliations}</li>
                  )}
                </ul>
                <ul className="userprofile_page_main_list">
                  <li className="userprofile_page_list">Website URL:</li>
                  {addAttorneyDetailButton ? (
                    <input
                      type="text"
                      style={{ width: "180px" }}
                      onChange={(e) => handleChanges(e, "websiteUrl")}
                      value={data.websiteUrl}
                    />
                  ) : (
                    <a
                      href={data.websiteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textTransform: "none" }}
                    >
                      {data.websiteUrl}
                    </a>
                  )}
                </ul>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  useEffect(() => {
    getBenificiarydata();
    getAttorneyData();
    getTrusteedata();
    base64ToImage();
    getAttorneyDetails();
  }, []);

  return (
    <>
      <div className="userprofile_mainpage">
        <div className="userprofile_basepage">
          <div className="userprofile_content_left">
            <div className="userprofilr_page_details">
              <div className="userprofile_image">
              <div className="default-profile">
                <img
                  className="userprofile_img"
                  src={imageSrc || defaultProfilePicture}
                  alt="Profile"
                />
                <div className="upload">
                  <label className="upload-button" htmlFor="fileInput">
                    <FontAwesomeIcon icon={faCamera} />
                  </label>
                </div>
                <input
                  id="fileInput"
                  ref={fileInputRef}
                  type="file"
                  onChange={handleChange}
                  accept="image/*"
                  style={{ display: "none" }}
                />
              </div>
            </div>
              <div className="userprofile_details">
                <ul className="userprofile_about">
{/*                   <li className="userprofile_name"> */}
{/*                    {user.firstName + " "} */}
{/*                     {user.lastName} */}
               <li className="userprofile_name">
                 {(() => {
                   const role = (user?.role || "").toLowerCase();
                   return role === "tenant_admin"
                     ? tenant?.organizationName || "Not Provided"
                     : `${user.firstName || ""} ${user.lastName || ""}`;
                 })()}
               </li>
{/*                     const role = (user?.role || "").toLowerCase(); */}
{/*                     {role === "tenant_admin" */}
{/*                     ? user.organizationName */}
{/*                     : `${user.firstName || ""} ${user.lastName || ""}`} */}
{/*                   </li> */}
{/*                   {role === "attorney" ? ( */}
{/*                     "" */}
{/*                   ) : ( */}
{/*                     <ul className="userprofile_about_deatils"> */}
{/*                       <li className="userprofile_list">Account Type:</li> */}
{/*                       {user.jointAccount ? ( */}
{/*                         <li>Joint Account ({user.accountType})</li> */}
{/*                       ) : ( */}
{/*                         <li>Primary Account</li> */}
{/*                       )} */}
{/*                     </ul> */}
{/*                   )} */}

{role === "attorney" || role === "tenant_admin" ? null : (
  <ul className="userprofile_about_deatils">
    <li className="userprofile_list">Account Type:</li>
{/*     {user.jointAccount ? ( */}
{/*       <li>Joint Account ({user.accountType})</li> */}
{/*     ) : ( */}
      {user.accountType === "secondary" ? (
            <li>Joint Account (secondary)</li>
          ) : (
      <li>Primary Account</li>
    )}
  </ul>
)}

                  <ul className="userprofile_about_deatils">
                    <li className="userprofile_list">Username:</li>
                    <li>{user.username} </li>
                  </ul>
                  <ul className="userprofile_about_deatils">
                    {" "}
                    <li className="userprofile_list">Email:</li>
{/*                     <li> {user.email}</li> */}
                  <li>{user?.tenant?.email || user?.email || "Not Provided"}</li>
                  </ul>

                  {!(
                    user.accountType === "secondary" ||
                    user.accountType === "normal" ||
//                     role === "attorney"
                role === "attorney" || role === "tenant_admin"  || role === "tenant_user"
                  ) && (
                    <ul className="userprofile_about_deatils">
                      <li className="userprofile_list">
                        Secondary User Editable:
                      </li>
                      {user.isSecondaryUserEditable === "true" ? (
                        <li>Read & Write</li>
                      ) : (
                        <li>Read Only</li>
                      )}
                    </ul>
                  )}

                {role !== "tenant_admin" && (
                  <ul className="userprofile_about_deatils">
                    <li className="userprofile_list">Date of birth:</li>
                    <li> {user.dob}</li>
                  </ul>
                  )}
                </ul>
              </div>
            </div>
{/*             <div className="userprofile_edit"> */}
{/*               <Link to={`/${role}/profile/edit`}> */}
{/*                 <button className="userprofile_edit_btn"> */}
{/*                   edit */}
{/*                   <FontAwesomeIcon */}
{/*                     className="userprofile_edit_icon" */}
{/*                     icon={faPen} */}
{/*                   /> */}
{/*                 </button> */}
{/*               </Link> */}
{/*            11/ </div> */}
           <div className="userprofile_edit">
             <button
               className="userprofile_edit_btn"
               onClick={() => {
                         let roleLower = user.role?.toLowerCase();
//                  const pathBase =
//         roleLower === "tenant_admin" || roleLower === "org_user"
//                      ? "organization"
//                      : user.role?.toLowerCase();

              let pathBase;

              if (roleLower === "tenant_admin" || roleLower === "tenant_user") {
                pathBase = "organization";
              } else if (roleLower === "org_user") {
                pathBase = "user"; // ✅ org_user uses user profile editor
              } else {
                pathBase = roleLower;
              }
                 navigate(`/${pathBase}/profile/edit`);
               }}
             >
               edit
               <FontAwesomeIcon
                 className="userprofile_edit_icon"
                 icon={faPen}
               />
             </button>
           </div>
          </div>
          <div className="userprofile_content_right">
            <div className="userprofile_page_details">
              <div className="userprofile_container">
                <h3>Basic Information</h3>
{/*                 {role !== "tenant_admin" && ( */}
{/*                 <ul className="userprofile_page_main_list"> */}
{/*                   <li className="userprofile_page_list"> Phone number: </li> */}
{/*                   <li>{user.phoneNo}</li> */}
{/* <li>{user.phoneNo || user.contactNumber || "Not Provided"}</li> */}

{/*                 </ul> */}
{/*                 <ul className="userprofile_page_main_list"> */}
{/*                   <li className="userprofile_page_list"> gender :</li> */}
{/*                   <li>{user.gender}</li> */}
{/*                 </ul> */}
{/*                 <ul className="userprofile_page_main_list"> */}
{/*                   <li className="userprofile_page_list">Marital: </li> */}
{/*                   <li>{user.meritalStatus}</li> */}
{/*                 </ul> */}
{/*                 <ul className="userprofile_page_main_list"> */}
{/*                   <li className="userprofile_page_list">Job Status:</li> */}
{/*                   <li>{user.jobStatus}</li> */}
{/*                 </ul> */}
{/*                 )} */}
<ul className="userprofile_page_main_list">
     <li className="userprofile_page_list"> Phone number: </li>
      <li>
        {role === "tenant_admin"
          ? tenant?.contactNumber || "Not Provided"
          : user?.phoneNo || "Not Provided"}
      </li>
   </ul>
{role !== "tenant_admin" &&  role !== "tenant_user" &&(
  <>

    <ul className="userprofile_page_main_list">
      <li className="userprofile_page_list">Gender:</li>
      <li>{user.gender}</li>
    </ul>

    <ul className="userprofile_page_main_list">
      <li className="userprofile_page_list">Marital:</li>
      <li>{user.meritalStatus}</li>
    </ul>

    <ul className="userprofile_page_main_list">
      <li className="userprofile_page_list">Job Status:</li>
      <li>{user.jobStatus}</li>
    </ul>
  </>
)}

              </div>
            </div>
            <div className="userprofile_security">
              <h3>Privacy & Security</h3>
              <div className="userprofile_buttons">
                <button
                  className="userprofile_changePassword"
                  onClick={togglePopup}
                >
                  change password
                </button>
                <form onSubmit={handleSubmit}>
                  {isPopupOpen && (
                    <div ref={popupRef} className="change_pass">
                      <ul className="change_pass_main">
                        <li className="change_pass_list">
                          <h4>Old Password :</h4>
                          <div className="password-input-container">
                            <input
                              type={showCurrentPassword ? "text" : "password"}
                              name="currentPassword"
                              value={passwordData.currentPassword}
                              onChange={handlePassChange}
                              required
                            />
                            <button
                              className="toggle-password-button"
                              type="button"
                              onClick={() =>
                                handleTogglePassword("currentPassword")
                              }
                            >
                              <FontAwesomeIcon
                                icon={showCurrentPassword ? faEyeSlash : faEye}
                              />
                            </button>
                          </div>
                        </li>
                        <li className="change_pass_list">
                          <h4>New Password :</h4>
                          <div className="password-input-container">
                            <input
                              type={showNewPassword ? "text" : "password"}
                              name="newPassword"
                              value={passwordData.newPassword}
                              onChange={handlePassChange}
                              required
                            />
                            <button
                              className="toggle-password-button"
                              type="button"
                              onClick={() =>
                                handleTogglePassword("newPassword")
                              }
                            >
                              <FontAwesomeIcon
                                icon={showNewPassword ? faEyeSlash : faEye}
                              />
                            </button>
                          </div>
                        </li>
                        <li className="change_pass_list">
                          <h4>Confirm Password :</h4>
                          <div className="password-input-container">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              value={passwordData.confirmPassword}
                              onChange={handlePassChange}
                              required
                            />
                            <button
                              className="toggle-password-button"
                              type="button"
                              onClick={() =>
                                handleTogglePassword("confirmPassword")
                              }
                            >
                              <FontAwesomeIcon
                                icon={showConfirmPassword ? faEyeSlash : faEye}
                              />
                            </button>
                          </div>
                        </li>
                        <div className="change_pass_btn">
                          <button
                            className="change_pass_cancel_btn"
                            onClick={togglePopup}
                          >
                            Cancel
                          </button>
                          <Tooltip
                            title="Password must be at least 10 characters long and
                              include an uppercase letter, a special character,
                              and a number."
                          >
                            <button
                              className="change_pass_save_btn"
                              type="submit"
                            >
                              Save
                            </button>
                          </Tooltip>
                        </div>
                      </ul>
                    </div>
                  )}
                </form>
              </div>
            {/* Two-Factor Authentication Section */}
            <div className="two_factor_auth">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Authentication Status: {" "}
              {twoFactorStatus === "INACTIVE" ? (
                <span className="clickable-text" onClick={handleEnable2FA}>
                  {twoFactorStatus}
                  </span>
              ):(
                twoFactorStatus
              )}
            </p>
            </div>
            <div className="terms-download-text">
              <span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Terms and Conditions:</span>{" "}
              <FaDownload
                onClick={handleDownloadTerms}
                title="Download Terms and Conditions"
                style={{ cursor: "pointer", fontSize: "18px", color: "#007bff", marginLeft: "8px" }}
              />
            </div>
           {/* Add Security Questions clickable text */}
           {/* Add Security Questions clickable text */}
          <div className="security-questions-row">
            {/* Add Security Questions clickable text */}
            <div
              className="terms-download-text security-questions-link"
              onClick={toggleSecurityPopup}
            >
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Security Questions for Forgot Password
              </span>
            </div>

            {/* Switch Button */}
            <label className="switch">
  <input
    type="checkbox"
    checked={securityData.enabled}
    onChange={(e) => {
      const enabled = e.target.checked;

      toggleSecurityQuestions({ username, enabled })
        .then((res) => {
          toast.success(res, { position: toast.POSITION.BOTTOM_CENTER });

          setSecurityData((prev) => ({ ...prev, enabled }));

          const updatedUser = { ...storedUser, securityQuestionsEnabled: enabled };
          localStorage.setItem("user", JSON.stringify(updatedUser));
        })
        .catch(() => {
          toast.error("Failed to update security setting", {
            position: toast.POSITION.BOTTOM_CENTER,
          });

          setSecurityData((prev) => ({ ...prev, enabled: !enabled }));
        });
    }}
  />
  <span className="slider round"></span>
</label>

          </div>
            {/* Security Questions Popup */}
            {isSecurityPopupOpen && (
              <form onSubmit={handleSecuritySubmit}>
                <div ref={popupRef} className="change_pass">
                  <ul className="change_pass_main">

                    {/* Question 1 */}
                    <li className="change_pass_list1">
                      <p>Question 1 :</p>
                      <select
                        name="question1"
                        value={securityData.question1}
                        onChange={handleSecurityChange}
                        required
                      >
                        <option value="">-- Select a question --</option>
                        {predefinedQuestions.map((q, i) => (
                          <option key={i} value={q}>
                            {q}
                          </option>
                        ))}
                        <option value="custom">Other (Create your own)</option>
                      </select>

                      {securityData.question1 === "custom" && (
                        <input
                          type="text"
                          name="customQuestion1"
                          value={securityData.customQuestion1}
                          onChange={handleSecurityChange}
                          placeholder="Enter your custom question"
                          required
                        />
                      )}

                      <p>Answer :</p>
                      <input
                        type="text"
                        name="answer1"
                        value={securityData.answer1}
                        onChange={handleSecurityChange}
                        placeholder="Enter your answer"
                        required
                      />
                    </li>

                    {/* Question 2 */}
                    <li className="change_pass_list1">
                      <p>Question 2 :</p>
                      <select
                        name="question2"
                        value={securityData.question2}
                        onChange={handleSecurityChange}
                      >
                        <option value="">-- Select a question --</option>
                        {predefinedQuestions.map((q, i) => (
                          <option key={i} value={q}>
                            {q}
                          </option>
                        ))}
                        <option value="custom">Other (Create your own)</option>
                      </select>

                      {securityData.question2 === "custom" && (
                        <input
                          type="text"
                          name="customQuestion2"
                          value={securityData.customQuestion2}
                          onChange={handleSecurityChange}
                          placeholder="Enter your custom question"
                          required
                        />
                      )}

                      <p>Answer :</p>
                      <input
                        type="text"
                        name="answer2"
                        value={securityData.answer2}
                        onChange={handleSecurityChange}
                        placeholder="Enter your answer"
                      />
                    </li>

                    <div className="change_pass_btn">
                      <button
                        className="change_pass_cancel_btn"
                        type="button"
                        onClick={toggleSecurityPopup}
                      >
                        Cancel
                      </button>
                      <button className="change_pass_save_btn" type="submit">
                        Save
                      </button>
                    </div>
                  </ul>
                </div>
              </form>
            )}

            </div>
          </div>
          {showQrPopup && (
            <div className="auth-popup-overlay">
              <div className="auth-popup-container">
                <div className="auth-popup-card">
                  <h3 className="qr-heading">Scan QR Code</h3>
                  <p className="qr-scanheading">Scan this QR code with Google Authenticator:</p>
                  <QRCodeSVG className="qrcode" value={qrCode} size={250} />

                  {/* OTP Input */}
                  <input
                    type="text"
                    className="auth-input"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />

                  {/* Verify OTP */}
                  <button className="auth-verify-btn1" onClick={handleVerifyOTP}>
                    Verify OTP
                  </button>

                  {/* Close Popup */}
                  <button className="auth-close-btn1" onClick={() => setShowQrPopup(false)}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* new card  */}
          {attorneySection}
          <div className="userprofile_content_down">
            <div className="userprofile_customer_care">
              <h3>Customer Care </h3>
              <div className="userprofile_helpcenter_btn">
                <li style={{ listStyle: "disc", color: "black" }}>
                  <button className="userprofile_faq">
                    frequently asked questions
                  </button>
                </li>
                <li style={{ listStyle: "disc", color: "black" }}>
                  <button className="userprofile_helpcenter">
                    help center
                  </button>
                </li>
              </div>
            </div>
            <div className="userprofile_address">
              <h3>Address Information </h3>
              <div className="userprofile_address_list">
                <ul className="userprofile_permanent_address">
                  <li className="userprofile_permanent_address_list">
                    permanent address :
                  </li>
                  <li>
                    {user.street && `${user.street}, `}{" "}
                    {user.apartment && `${user.apartment}, `}{" "}
                  </li>
                  <li>
                    {user.city && `${user.city}, `}{" "}
                    {user.state && `${user.state}, `}{" "}
                    {user.country && `${user.country}, `}{" "}
                    {user.zip && `${user.zip} `}
                  </li>
                </ul>

              </div>
            </div>
          </div>
          {/*{trusteeBeneficiarySection}*/}

        <div className="userprofile_content_down">
          {trusteeBeneficiarySection}
          <div className="userprofile_empty_box"></div>
        </div>

          {role === "attorney" && (
            <div className="userprofile_trustee_beneficiary_details">
              <div className="userprofile_trustee_beneficiary_base">
                <div className="userprofile_beneficiary_details">
                  <h3> Remove Account </h3>
                  <div className="userprofile_buttons">

                  </div>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
    </>
  );
}
export default Userprofile;